export default "__VITE_ASSET__acd550ca__"